export default function applyAccentOverrides(components = {}, accent) {
    const inputLabel = components.MuiInputLabel || {};
    const outlinedInput = components.MuiOutlinedInput || {};

    return {
        ...components,
        MuiInputLabel: {
            ...inputLabel,
            styleOverrides: {
                ...inputLabel.styleOverrides,
                root: {
                    ...inputLabel.styleOverrides?.root,
                    '&.Mui-focused:not(.Mui-error)': { color: accent }
                }
            }
        },
        MuiOutlinedInput: {
            ...outlinedInput,
            styleOverrides: {
                ...outlinedInput.styleOverrides,
                root: {
                    ...outlinedInput.styleOverrides?.root,
                    '&.Mui-focused:not(.Mui-error) .MuiOutlinedInput-notchedOutline': {
                        borderColor: accent
                    }
                }
            }
        },
        MuiCheckbox: {
            styleOverrides: {
                root: { '&.Mui-checked:not(.Mui-disabled)': { color: accent } }
            }
        },
        MuiRadio: {
            styleOverrides: {
                root: { '&.Mui-checked:not(.Mui-disabled)': { color: accent } }
            }
        },
        MuiSwitch: {
            styleOverrides: {
                switchBase: {
                    '&.Mui-checked:not(.Mui-disabled)': { color: accent },
                    '&.Mui-checked:not(.Mui-disabled) + .MuiSwitch-track': {
                        backgroundColor: accent
                    }
                }
            }
        },
        MuiTabs: {
            styleOverrides: { indicator: { backgroundColor: accent } }
        },
        MuiTab: {
            styleOverrides: {
                root: { '&.Mui-selected': { color: accent } }
            }
        }
    };
}
